import { Injectable, Inject } from '@angular/core';
import { Auth } from 'aws-amplify';
import { CognitoUser } from 'amazon-cognito-identity-js';

import * as  crypto from 'crypto-js';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private window: Window;

  private cognitoUser: CognitoUser & { challengeParam: { mobile: string } };
  constructor(@Inject(DOCUMENT) private document: Document) {
    this.window = this.document.defaultView;
  }

  private getRandomString(bytes: number) {
    const randomValues = new Uint8Array(bytes);
    this.window.crypto.getRandomValues(randomValues);
    return Array.from(randomValues).map(this.intToHex).join('');
  }

  private intToHex(nr: number) {
    return nr.toString(16).padStart(2, '0');
  }

  public async signUp(fullName: string,mobile: string, email: string,preferred_username: string,
    profile:string) {  
    const params = {
      username: mobile,
      password: this.getRandomString(30),
      attributes: {
        name: fullName,
        phone_number:mobile,
        email: email,
        preferred_username: preferred_username,
        profile: profile
      }
    };
    if(localStorage.getItem('campaign') === 'b2c') {
      params.attributes['profile'] = 'b2c';
    }
    await Auth.signUp(params);
  }
    public async updateUserUuId(useruuId:string){     
        const userDetails = await Auth.userAttributes(this.cognitoUser);
    
        var customUpdated = false;
      // to know if 'useruuId' is set 
        for(var key in userDetails){
            if(userDetails[key].getName()=='custom:useruuId' ){
              customUpdated = true;
              break;
            }
        };    
          
        //if not set we ned to set 'useruuId' as the same value as 'sub'
        if(customUpdated == false){
          // for(var key in userDetails){
          //   if(userDetails[key].getName()=='sub' ){
          //     const result = Auth.updateUserAttributes(this.cognitoUser, {
          //       'custom:useruuId': userDetails[key].getValue()           
          //     }          
          //   );
          //   break;    
          //   }
          // };
          const result = Auth.updateUserAttributes(this.cognitoUser, {
                  'custom:useruuId': useruuId           
                });
        }
      }

  public async signIn(mobile: string) {
    this.cognitoUser = await Auth.signIn(mobile);
  }

  public async answerCustomChallenge(data: string) {
    this.cognitoUser = await Auth.sendCustomChallengeAnswer(this.cognitoUser, data);
    return this.isAuthenticated();
  }

  public async isAuthenticated() {
    try {
      await Auth.currentSession();
      return true;
    } catch {
      return false;
    }
  }


  public async signOut() {
    await Auth.signOut();
    localStorage.clear();
  }


}
